// state is not the application state, only the state this
// reducer is responsible for.
import {FETCH_REPORTS, GAME_SELECTED} from "../constants/ActionTypes";

// Returns a single game object
export default function (state = null, action) {

   switch (action.type) {
      case GAME_SELECTED:
         const newGameId = action.payload;
         if (!state) return null;
         // wipe out if gameId's don't match
         if (state.gameId !== newGameId) return null;
         return state;
      case FETCH_REPORTS:
         const payload = action.payload;

         if (payload) {
            return payload;         // payload is of the form: { gameStats: gameStats, gameId: game.id }
         } else {
            return state;
         }
      default:
         return state;
   }
}


// WEBPACK FOOTER //
// ./src/reducers/reducer_reports.js